<template>
  <div class="d-flex flex-column ts-mb-6 ts-h-64">
    <h1 class="section-divider-underline">
      {{ $t('bankProfile.detail') }}
    </h1>
    <div class="ts-overflow-auto ts-h-64" style="max-height: 50vh">
      <table class="ts-w-full">
        <thead>
          <tr class="ts-uppercase ts-bg-gray-200 ts-h-8 ts-sticky ts-top-0">
            <th class="ts-pl-8" style="width: 16%">
              <label class="required ts-m-0">{{
                $t('bankProfile.qrCode')
              }}</label>
            </th>
            <th class="ts-whitespace-nowrap ts-pl-2" style="width: 16%">
              <label class="required ts-m-0">{{
                $t('bankProfile.accountNumber')
              }}</label>
            </th>
            <th class="ts-whitespace-nowrap" style="width: 18%">
              <label class="required ts-m-0">{{
                $t('bankProfile.accountName')
              }}</label>
            </th>
            <th class="ts-whitespace-nowrap" style="width: 16%">
              <label class="ts-m-0">{{
                $t('bankProfile.swiftCode')
              }}</label>
            </th>
            <th class="ts-whitespace-nowrap" style="width: 26%">
              <label class="ts-m-0">{{ $t('bankProfile.remark') }}</label>
            </th>
            <th style="width: 5%" class="ts-text-center">
              <a
                href="#"
                @click.prevent="addRow"
                class="hover:ts-no-underline ts-text-right"
              >
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in model.detail"
            :key="index"
            class="ts-cursor-pointer hover:ts-bg-gray-300 ts-w-full ts-h-10"
          >
            <td>
              <ts-image-input
                :file="model.detail[index].image_qr_code ? model.detail[index].image_qr_code : file"
                @input="file => (model.detail[index].image_qr_code = file)"
                :width="100"
                :height="100"
                crop
              ></ts-image-input>
              <div class="invalid-feedback" v-if="errors.has('detail.' + index + '.image_qr_code')">
                {{ errors.first('detail.' + index + '.image_qr_code') }}
              </div>
            </td>
            <td class="ts-whitespace-nowrap ts-pl-2">
              <input
                v-model.trim="item.account_number"
                :placeholder="$t('bankProfile.accountNumber')"
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': errors.has(
                    'detail.' + index + '.account_number'
                  ),
                }"
              />
            </td>
            <td class="ts-whitespace-nowrap">
              <input
                v-model.trim="item.account_name"
                :placeholder="$t('bankProfile.accountName')"
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': errors.has('detail.' + index + '.account_name'),
                }"
              />
            </td>
            <td class="ts-whitespace-nowrap">
              <input
                v-model.trim="item.swift_code"
                :placeholder="$t('bankProfile.swiftCode')"
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': errors.has('detail.' + index + '.swift_code'),
                }"
              />
            </td>
            <td class="ts-whitespace-nowrap">
              <input
                v-model.trim="item.remarks"
                :placeholder="$t('bankProfile.remark')"
                type="text"
                class="form-control"
              />
            </td>
            <td class="ts-whitespace-nowrap ts-text-green-500 ts-text-center">
              <a
                href="#"
                :key="'a' + index"
                class="ts-text-right ts-text-red-600 hover:ts-text-red-600"
                @click.prevent="removeRow(index)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'detail',

  props: ['value', 'validation'],
  data() {
    return {
      model: {},
      file: require('@/assets/upload-image.png'),
      errors: new Errors(),
    }
  },
  computed: {
    ...mapState('bankProfile', ['edit_data']),
  },
  created() {
    this.model = this.value
  },
  methods: {
    addRow() {
      this.model.detail.push({
        account_id: 0,
        account_number: null,
        account_name: null,
        swift_code: null,
        image_qr_code: null,
        remarks: null,
      })
    },
    removeRow(index) {
      this.model.detail.splice(index, 1)
    },
  },
  watch: {
    validation: {
      handler() {
        this.errors = new Errors(this.validation.errors)
      },
      deep: true,
    },
  },
}
</script>
<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  /* border-bottom: 1px solid #eee; */
  font-size: 16px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}
</style>
